import React from "react";

const ProgressBar = ({ progress }) => {
    return (
        <div className="flex flex-col items-center w-full max-w-md mx-auto bg-white bg-opacity-10 p-4 rounded-md shadow-md">
            <p className="text-white text-lg font-medium">Processing...</p>
            <div className="w-full bg-gray-600 rounded-full h-4 mt-3 overflow-hidden">
                <div
                    className="h-full bg-green-600 transition-all duration-500"
                    style={{ width: `${progress}%` }}
                />
            </div>
            <p className="text-white mt-2 text-sm">{Math.round(progress)}%</p>
        </div>
    );
}

export default ProgressBar;
